module.exports = __webpack_public_path__ + "img/tuijian_chanpin1.a547a08b.png";